import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/profile-message-actions';


export const initialState = resourceState;

export default resourceReducerFactory(initialState, types);
